export default __webpack_public_path__ + "static/media/stepBlogger-2.fdd1d19a.svg";